module.exports = __webpack_public_path__ + "static/media/creativecommonslogo.fa9f69bc.svg";